import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import axiosInstance from '../apiServices/axios';
import { ALERTS, NOTE, NOTES, NOTIFICATIONS, READ_NOTIFICATION, REMOVE_NOTIFICATION } from '../apiServices/api_routes';
export const GetAlerts = createAsyncThunk('Alerts', async () => {
    const data = await axiosInstance.post(ALERTS, {
        project_id: localStorage['project_id'],
    });
    return data;
});
export const GetNotifications = createAsyncThunk('Notifications', async () => {
    const data = await axiosInstance.get(NOTIFICATIONS);
    return data;
});
export const GetNotes = createAsyncThunk('GET_NOTES', async () => {
    const projectId = localStorage['project_id'];
    console.log('GetNotes - project_id:', projectId);
    console.log('GetNotes - API URL:', NOTES + projectId + '/');
    try {
        const data = await axiosInstance.get(NOTES + projectId + '/');
        console.log('GetNotes - API response:', data);
        return data;
    } catch (error) {
        console.error('GetNotes - API error:', error);
        throw error;
    }
});
export const PostNotesPage = createAsyncThunk('POST_NOTES_PAGE', async body => {
    const data = await axiosInstance.post(NOTES + localStorage['project_id'] + '/', body);
    return data;
});
export const DeleteNotePage = createAsyncThunk('DELETE_NOTES_PAGE', async id => {
    const data = await axiosInstance.delete(NOTES + localStorage['project_id'] + '/' + id + '/');
    return data;
});
export const PatchNotesPage = createAsyncThunk('PATCH_NOTES_PAGE', async body => {
    const data = await axiosInstance.patch(NOTES + localStorage['project_id'] + '/' + body?.id + '/', body);
    return data;
});
export const PostNote = createAsyncThunk('POST_NOTES', async body => {
    const data = await axiosInstance.post(NOTE + body?.notepad + '/' + localStorage['project_id'] + '/', body);
    return data;
});
export const PatchNote = createAsyncThunk('PATCH_NOTES', async body => {
    const payload = { notes: body?.notes, notepad: body?.notepad };
    const data = await axiosInstance.patch(NOTE + body?.notepad + '/' + localStorage['project_id'] + '/' + body?.id + '/', payload);
    return data;
});

export const MoveNote = createAsyncThunk('MOVE_NOTE', async ({ noteId, sourceNotepadId, targetNotepadId }) => {
    const data = await axiosInstance.post(`/tools/notes/${sourceNotepadId}/${localStorage['project_id']}/${noteId}/move_to_notepad/`, { target_notepad_id: targetNotepadId });
    return data;
});
export const DeleteNote = createAsyncThunk('DELETE_NOTES', async body => {
    const data = await axiosInstance.delete(NOTE + body?.notepad + '/' + localStorage['project_id'] + '/' + body?.id + '/');
    return data;
});

// Notepad sharing (sections sharing)
export const ShareNotepad = createAsyncThunk('SHARE_NOTEPAD', async ({ notepadId, userIds }, { getState }) => {
    // Merge with existing shared users so backend .set() doesn't overwrite
    const state = getState();
    const current = state?.dashboard?.notes?.find(n => n?.id === notepadId);
    const existingIds = Array.isArray(current?.shared_with) ? current.shared_with : [];
    const mergedIds = Array.from(new Set([...(existingIds || []), ...(userIds || [])]));

    // Persist merged list
    const url = `/tools/notepad/${localStorage['project_id']}/${notepadId}/share/`;
    const data = await axiosInstance.post(url, { user_ids: mergedIds });

    // Build display names from team state for immediate UI
    const team = state?.team?.projectUsersAll || [];
    const userNames = mergedIds.map(id => {
        const u = team.find(t => t?.value?.user_id === id);
        return u?.value?.full_name || `User ${String(id).slice(0, 8)}`;
    });

    return { response: data, notepadId, userIds: mergedIds, userNames };
});

export const UnshareNotepad = createAsyncThunk('UNSHARE_NOTEPAD', async ({ notepadId, userId }, { getState }) => {
    // DELETE /tools/notepad/{notepad_id}/{project_id}/share/{user_id}/
    const url = `/tools/notepad/${notepadId}/${localStorage['project_id']}/share/${userId}/`;
    const data = await axiosInstance.delete(url);

    const state = getState();
    const current = state?.dashboard?.notes?.find(n => n?.id === notepadId);
    const existingIds = Array.isArray(current?.shared_with) ? current.shared_with : [];
    const nextIds = existingIds.filter(id => id !== userId);
    const team = state?.team?.projectUsersAll || [];
    const userNames = nextIds.map(id => {
        const u = team.find(t => t?.value?.user_id === id);
        return u?.value?.full_name || `User ${String(id).slice(0, 8)}`;
    });

    return { response: data, notepadId, userId, nextIds, userNames };
});
export const RemoveNotification = createAsyncThunk('REMOVE_NOTIFICATION', async ({ id }) => {
    const data = await axiosInstance.delete(REMOVE_NOTIFICATION + id);
    return data;
});
export const ReadNotification = createAsyncThunk('READ_NOTIFICATION', async ({ id }) => {
    const data = await axiosInstance.post(READ_NOTIFICATION + id + '/');
    return data;
});

export const RewriteNote = createAsyncThunk('REWRITE_NOTE', async ({ note_text, mode = 'rewrite' }) => {
    const data = await axiosInstance.post(`/tools/gpt_automation/${localStorage['project_id']}/rewrite-notes/`, {
        note_text,
        mode,
    });
    return data;
});
export const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState: {
        notificationsLoading: true,
        notifications: [],
        alertsLoading: true,
        alerts: [],
        status: null,
        unReadNotificationCount: 0,
        notes: [],
        rewriteNoteLoading: false,
        rewrittenNote: null,
    },
    reducers: {
        setNotifications: (state, action) => {
            return { ...state, notifications: action.payload };
        },
        setAlerts: (state, action) => {
            return { ...state, alerts: action.payload };
        },
        clearRewrittenNote: state => {
            state.rewrittenNote = null;
            state.rewriteNoteLoading = false;
        },
    },
    extraReducers: {
        [GetAlerts.fulfilled]: (state, { payload }) => {
            const data = payload?.data?.alerts?.filter((v, i, a) => a?.indexOf(v) === i);
            state.alerts = data;
            state.alertsLoading = false;
        },
        [GetAlerts.rejected]: (state, action) => {
            state.error = true;
            state.errorMessage = action?.error?.message;
            state.alerts = [];
            state.alertsLoading = false;
        },

        [GetNotifications.fulfilled]: (state, { payload }) => {
            state.notifications = payload?.data;
            state.notificationsLoading = false;
            state.unReadNotificationCount = payload?.data?.reduce((prev, next) => {
                return prev + next?.unread;
            }, 0);
        },
        [GetNotifications.rejected]: (state, action) => {
            state.error = true;
            state.errorMessage = action?.error?.message;
            state.notifications = [];
            state.notificationsLoading = false;
        },
        [RemoveNotification.fulfilled]: (state, action) => {
            // state.notifications = payload?.data;
            toast.success('Successfully Removed');
            state.notifications = state.notifications?.filter(item => item.id !== action.meta?.arg?.id);
        },
        [RemoveNotification.rejected]: (state, action) => {
            toast.error('Notification failed to remove ');
        },
        [ReadNotification.fulfilled]: (state, action) => {
            // state.notifications = payload?.data;
            // toast.success('Successfully Removed');
            state.notifications = state.notifications?.map(item => {
                if (item.id === action.meta?.arg?.id) {
                    return { ...item, unread: false };
                } else return item;
            });
        },
        [ReadNotification.rejected]: (state, action) => {
            // toast.error('Notification failed to remove ');
        },
        //GetNotes
        [GetNotes.fulfilled]: (state, { payload }) => {
            console.log('GetNotes.fulfilled payload:', payload);
            state.notes = payload.data;
        },
        [GetNotes.rejected]: (state, { error }) => {
            console.error('GetNotes.rejected error:', error);
            toast.error('Failed to load notepads');
        },
        //PostNotesPage
        [PostNotesPage.fulfilled]: (state, { payload }) => {
            state.notes.push(payload.data);
        },
        [PostNotesPage.rejected]: (state, { payload }) => {
            toast.error('Error');
        },
        //DeleteNotePage
        [DeleteNotePage.fulfilled]: (state, { meta }) => {
            state.notes = state.notes?.filter(item => item?.id !== meta?.arg);
        },
        [DeleteNotePage.rejected]: (state, { payload }) => {
            toast.error('Error');
        },
        //PatchNotesPage
        [PatchNotesPage.fulfilled]: (state, { payload }) => {
            state.notes = state.notes?.map(item => {
                if (item?.id === payload?.data?.id) return payload?.data;
                else return item;
            });
        },
        [PatchNotesPage.rejected]: (state, { payload }) => {
            toast.error('Error');
        },
        //PostNote
        [PostNote.pending]: (state, { payload }) => {},
        [PostNote.fulfilled]: (state, action) => {
            const note = {
                ...action.payload?.data,
                notepad: action.meta?.arg?.notepad,
                notes: action.payload?.data?.notes || action.meta?.arg?.notes || '',
            };
            const notepadId = action.meta?.arg?.notepad;
            state.notes = state.notes?.map(item => {
                if (item?.id === notepadId) {
                    const existing = Array.isArray(item?.notes) ? item.notes : [];
                    if (note?.id && existing.some(n => n?.id === note.id)) {
                        return {
                            ...item,
                            notes: existing.map(n => (n?.id === note.id ? { ...n, ...note } : n)),
                        };
                    }
                    return { ...item, notes: [...existing, note] };
                }
                return item;
            });
        },
        [PostNote.rejected]: (state, { payload }) => {
            toast.error('Error');
        },
        //PatchNote
        [PatchNote.pending]: (state, { payload }) => {},
        [PatchNote.fulfilled]: (state, action) => {
            const updated = action.payload?.data || {};
            const requestNotes = action.meta?.arg?.notes;
            const noteId = updated?.id || action.meta?.arg?.id;
            const notepadId = updated?.notepad || action.meta?.arg?.notepad;
            const updatedAt = updated?.updated_at || updated?.updated || new Date().toISOString();
            state.notes = state.notes?.map(item => {
                if (item?.id === notepadId) {
                    const nextNotes = (item?.notes || []).map(note =>
                        note?.id === noteId
                            ? { ...note, ...updated, id: noteId, notes: requestNotes ?? updated?.notes ?? note.notes, updated_at: updatedAt }
                            : note
                    );
                    return { ...item, notes: nextNotes };
                }
                return item;
            });
        },
        [PatchNote.rejected]: (state, { payload }) => {
            toast.error('Error');
        },
        //MoveNote
        [MoveNote.pending]: (state, { payload }) => {},
        [MoveNote.fulfilled]: (state, action) => {
            const { noteId, sourceNotepadId, targetNotepadId } = action.meta.arg;
            const newNote = action.payload?.data?.new_note;

            // Remove note from source notepad
            state.notes = state.notes.map(notepad => {
                if (notepad.id === sourceNotepadId) {
                    const filteredNotes = notepad.notes?.filter(note => note.id !== noteId) || [];
                    return { ...notepad, notes: filteredNotes };
                }
                return notepad;
            });

            // Add note to target notepad
            if (newNote) {
                state.notes = state.notes.map(notepad => {
                    if (notepad.id === targetNotepadId) {
                        const existingNotes = notepad.notes || [];
                        return { ...notepad, notes: [...existingNotes, newNote] };
                    }
                    return notepad;
                });
            }
        },
        [MoveNote.rejected]: (state, { payload }) => {
            toast.error('Failed to move note');
        },
        //DeleteNote
        [DeleteNote.fulfilled]: (state, { meta }) => {
            state.notes = state.notes.map(item => {
                if (item?.id === meta?.arg?.notepad) {
                    let filteredNotes = item?.notes?.filter(note => note?.id !== meta?.arg?.id);
                    return { ...item, notes: filteredNotes };
                } else return item;
            });
        },
        [DeleteNote.rejected]: (state, { payload }) => {
            toast.error('Error');
        },

        // Share Notepad (Section)
        [ShareNotepad.fulfilled]: (state, { payload }) => {
            const { notepadId, userIds } = payload;
            state.notes = state.notes?.map(item => {
                if (item?.id === notepadId) {
                    // Update shared_with with the merged user IDs
                    const merged = Array.from(new Set([...(item.shared_with || []), ...userIds]));

                    // Use names provided by the thunk for consistency
                    const userNames = payload.userNames || [];

                    return {
                        ...item,
                        shared_with: merged,
                        shared_with_names: userNames,
                    };
                }
                return item;
            });
            toast.success('Section shared successfully');
        },
        [ShareNotepad.rejected]: (state, { payload }) => {
            toast.error('Failed to share section');
        },

        // Unshare Notepad (Section)
        [UnshareNotepad.fulfilled]: (state, { payload }) => {
            const { notepadId, userId } = payload;
            state.notes = state.notes?.map(item => {
                if (item?.id === notepadId) {
                    const filtered = Array.isArray(payload.nextIds) ? payload.nextIds : (item.shared_with || []).filter(id => id !== userId);
                    const userNames = payload.userNames || [];

                    return {
                        ...item,
                        shared_with: filtered,
                        shared_with_names: userNames,
                    };
                }
                return item;
            });
            toast.success('Section unshared successfully');
        },
        [UnshareNotepad.rejected]: (state, { payload }) => {
            toast.error('Failed to unshare section');
        },
        //RewriteNote
        [RewriteNote.pending]: state => {
            state.rewriteNoteLoading = true;
        },
        [RewriteNote.fulfilled]: (state, { payload }) => {
            state.rewriteNoteLoading = false;
            if (payload?.data?.success) {
                // Strip images from AI response before storing
                const rewrittenNote = payload?.data?.rewritten_note || '';
                const strippedNote = rewrittenNote.replace(/<img[^>]*>/gi, '');
                state.rewrittenNote = strippedNote;
            } else {
                toast.error('Failed to rewrite note');
            }
        },
        [RewriteNote.rejected]: (state, { payload }) => {
            state.rewriteNoteLoading = false;
            toast.error('Error rewriting note');
        },
    },
});
export const { setNotifications, setMessages, setAlerts, clearRewrittenNote } = dashboardSlice.actions;
export default dashboardSlice.reducer;
